














































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import PatrolQueue from "@/components/event-queue/PatrolQueue.vue";
import ProcessingQueue from "@/components/ProcessingQueue.vue";
import PostProcessingQueue from "@/components/PostProcessingQueue.vue";
import ParkedQueue from "@/components/ParkedQueue.vue";
import OnTestQueue from "@/components/event-queue/OnTestQueue.vue";
import { UserPermissions, FeaturesList } from "@/store/types";
import { get } from "lodash";

const Eventqueue = namespace("eventqueue");

@Component({
	components: {
		PatrolQueue: PatrolQueue,
		ProcessingQueue: ProcessingQueue,
		ParkedQueue: ParkedQueue,
		PostProcessingQueue,
		"ontest-queue": OnTestQueue
	}
})
export default class AlarmQueueFooter extends Vue {
	@Eventqueue.Getter private getCountByType: (eventType: string) => number;
	@Getter private getPermissions: UserPermissions;
	@Getter private getFeaturesList: FeaturesList;

	private isMaximised: boolean = true;
	private selectedTab: number = 0;

	private get patrolEventCount() {
		return this.getCountByType("patrols");
	}
	private get parkedEventCount() {
		return this.getCountByType("parked");
	}
	private get processingEventCount() {
		return this.getCountByType("inProcess");
	}
	private get onTestEventCount() {
		return this.getCountByType("onTest");
	}
	private get postProcessingCount() {
		return this.getCountByType("postProcessing") ?? 0;
	}

	// Updates the selected tab
	private setSelectedTab(tabIndex) {
		this.isMaximised = true;
		this.selectedTab = tabIndex;
	}

	private get isProcessingTabEnabled(): boolean {
		return get(this.getFeaturesList, ["Alarms", "EventQueue", "DisableProcessingActiveAlarms"])
			? this.getPermissions.canProcessActiveAlarms
			: true;
	}

	private get isManualToursEnabled(): boolean {
		return get(this.getFeaturesList, ["Alarms", "EventQueue", "ManualTour"]);
	}
	
	private get isDisplayScheduleToursInAlarmsEnabled(): boolean {
		return get(this.getFeaturesList, ["Alarms", "EventQueue", "ShowToursInEventQueue"]);
	}

	private get isPostProcessingTabEnabled(): boolean {
		return get(this.getFeaturesList, ["Integration", "CCure", "UI", "PostProcessingQueue"]) && this.getPermissions.isAdmin;
	}

	//sets the name of the Tours tab based upon whether 'tours in queue' is on or off
	private get ToursTitle(): string {
		if(this.isDisplayScheduleToursInAlarmsEnabled) {
			return "Active Tours";
		}
		else {
			return "Tours";
		} 
	}

}
